<template>
    <div>
        <my-header
            isBack
        />

        <search-bar
            :keyword="keyword"
            isCancel
        />

        <result
            ref="result"
            :tabs="tabs"
            :keyword="keyword"
        />
    </div>
</template>

<script>
import MyHeader from '@/components/myHeader'
import SearchBar from '@/components/searchBar'

import Result from './components/result'
import { onBeforeRouteUpdate, useRoute } from 'vue-router'
import { ref } from '@vue/runtime-core'

export default {
    name: 'SearchResult',
    components: {
        MyHeader,
        SearchBar,
        Result
    },
    setup() {
        // init tabs
        const tabs = [
            { title: '文章', type: 'HTML'},
            { title: '视频', type: 'VIDEO'},
            { title: '书籍', type: 'PDF'}
        ]

        let keyword = ref(useRoute().query.keyword)

        onBeforeRouteUpdate(to => {
            keyword.value = to.query.keyword
        });

        return {
            tabs,
            keyword
        }
    },
    watch:{
        keyword(){
            // 当 关键词变化时 重新初始化
            this.$refs.result.init()
        }
    }
}
</script>

